/* ============
 * CreditNoteProduct Transformer
 * ============
 *
 * The transformer for the creditNoteProduct.
 */

import Transformer from './transformer';
import productTrans from './product';

export default class CreditNoteProductTransformer extends Transformer {

  static fetch(creditNoteProduct) {
    let product = [];
    if (creditNoteProduct.product) {
      product = productTrans.fetch(creditNoteProduct.product);
    }
    const data = Object.assign(product, {
      id: creditNoteProduct.id,
      orderProductId: creditNoteProduct.order_product_id,
      billProductId: creditNoteProduct.bill_product_id,
      orderProduct: creditNoteProduct.order_product,
      billProduct: creditNoteProduct.bill_product,
      orderProductDeposit: creditNoteProduct.order_product_deposit,
      productDepositId: creditNoteProduct.product_deposit_id,
      billId: creditNoteProduct.bill_id,
      taxId: creditNoteProduct.tax_id,
      taxPercentage: creditNoteProduct.tax_percentage,
      quantity: creditNoteProduct.quantity,
      price: creditNoteProduct.price,
      discount: creditNoteProduct.discount,
      billNote: creditNoteProduct.bill_note,
      refNumber: creditNoteProduct.ref_number,
      refId: creditNoteProduct.ref_id,
      refType: creditNoteProduct.ref_type,
      exceedCreditnoteAmount: creditNoteProduct.exceed_creditnote_amount,
    });
    return data;
  }

  static send(creditNoteProduct) {
    return {
      id: creditNoteProduct.id,
      price: creditNoteProduct.price,
      order_product_id: creditNoteProduct.orderProductId,
      bill_product_id: creditNoteProduct.billProductId,
      order_product: creditNoteProduct.orderProduct,
      product_deposit_id: creditNoteProduct.productDepositId,
      bill_product: creditNoteProduct.billProduct,
      bill_id: creditNoteProduct.billId,
      quantity: creditNoteProduct.quantity,
      discount: creditNoteProduct.discount,
      tax_id: creditNoteProduct.taxId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/creditNoteProduct.js